export default __webpack_public_path__ + "static/media/cathodic.1ca101e6.jpg";